module.exports = __webpack_public_path__ + "ab411f62eb02c3a8195dffe50125022b.png";